"use client";

import { useLocale } from "next-intl";
import { useTransition } from "react";
import { usePathname, useRouter } from "@/i18n/navigation";
import { routing } from "@/i18n/routing";

const LABELS: Record<string, string> = {
  hy: "ՀԱՅ",
  ru: "РУС",
  en: "ENG",
};

// Compact language selector that keeps the user on the same page.
export function LanguageSwitcher() {
  const locale = useLocale();
  const pathname = usePathname();
  const router = useRouter();
  const [isPending, startTransition] = useTransition();

  function switchTo(next: string) {
    if (next === locale) return;
    // usePathname() has no query string — re-attach it (and the hash) so
    // active filters/pagination survive the language switch. Read from
    // window at click time: event-handler only, so SSR/static stay happy.
    const suffix = window.location.search + window.location.hash;
    startTransition(() => {
      // Keep the current scroll position when switching language.
      router.replace(`${pathname}${suffix}`, { locale: next, scroll: false });
    });
  }

  return (
    <div
      className="flex items-center gap-1 rounded-full bg-sand/70 p-1"
      aria-label="Language"
    >
      {routing.locales.map((l) => (
        <button
          key={l}
          onClick={() => switchTo(l)}
          disabled={isPending}
          aria-current={l === locale ? "true" : undefined}
          className={`rounded-full px-2.5 py-1 text-xs font-semibold tracking-wide transition-colors ${
            l === locale
              ? "bg-forest-500 text-white"
              : "text-bark/75 hover:text-forest-600"
          }`}
        >
          {LABELS[l]}
        </button>
      ))}
    </div>
  );
}
